<template>
    <v-card>
        <v-card-title>
            <h2 style="text-align: center; width: 100%;">{{text_title}}</h2>
        </v-card-title>
        <v-card-text>
            <v-stepper v-model="step" style="box-shadow: none; hight: 100%;">
                <v-stepper-items>
                    <v-stepper-content step="1">
                        <v-select
                            v-model="search_label"
                            label="Pesquisar por"
                            outline
                            :items="[
                                { text: 'Email', value: 'email'},
                                { text: 'CPF', value: 'cpf'}
                            ]"
                        />
                        <v-text-field
                            outline
                            prepend-inner-icon="search"
                            v-if="search_label"
                            :label="`Digite o ${search_label == 'cpf' ? search_label.toUpperCase() : search_label} do representante`"
                            v-model="search"
                            :mask="search_label == 'cpf' ? '###.###.###-##' : ''"
                        />
                    </v-stepper-content>
                    <v-stepper-content step="2">
                        <v-list>
                            <v-list-tile
                                v-for="(item, index) in lista_de_pessoa"
                                :key="index"
                                avatar
                                @click="representante = item, step = 4"
                                >
                                <v-list-tile-avatar>
                                    <img v-if="item.url_imagem_perfil" :src="item.url_imagem_perfil">
                                    <v-icon color="primary" size="40" v-else>face</v-icon>
                                </v-list-tile-avatar>

                                <v-list-tile-content>
                                    <v-list-tile-title>{{item.nome_completo}}</v-list-tile-title>
                                    <v-list-tile-sub-title v-html="item.cpf"></v-list-tile-sub-title>
                                </v-list-tile-content>
                            </v-list-tile>
                            <v-list-tile v-if="lista_de_pessoa.length == 0">
                                <v-list-tile-title>Nenhum resultado foi encontrado</v-list-tile-title>
                            </v-list-tile>
                        </v-list>
                    </v-stepper-content>
                    <v-stepper-content step="3">
                        <v-layout justify-space-around wrap full-width>
                            <v-flex xs5>
                                <v-text-field label="Nome" v-model="representante.nome"></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field label="Sobrenome" v-model="representante.sobrenome"></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field label="CPF" mask="###.###.###-##" v-model="representante.cpf"></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field v-model="representante.telefone" label="Telefone" mask="(##) # ####-####"></v-text-field>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field label="Email" v-model="representante.email"></v-text-field>
                            </v-flex>
                            <v-flex xs12 v-if="verificacaoTelefone.cadastrado || (verificacaoTelefone.pessoa && representante && verificacaoTelefone.pessoa.id_pessoa !=  representante.id_pessoa)">
                                <v-card class="ma-2" elevation="4">
                                    <v-card-title class="justify-center">
                                        <h4
                                            v-if="verificacaoTelefone.cadastrado || verificacaoTelefone.pessoa"
                                            class="text-xs-center error--text"
                                        >
                                            Esse telefone já foi cadastrado
                                        </h4>
                                    </v-card-title>
                                    <v-card-text>
                                        <v-flex
                                            class="error--text"
                                            v-if="verificacaoTelefone.quantidade > 0"
                                        >
                                            {{ verificacaoTelefone.quantidade }} {{ verificacaoTelefone.quantidade === 1 ? 'pessoa cadastrou esse telefone' : 'pessoas cadastraram esse telefone' }}
                                        </v-flex>
                                        <v-flex
                                            class="error--text"
                                            v-if="verificacaoTelefone.ids_cadastrados.length > 0"
                                        >
                                            IDs que registraram esse telefone: <span v-for="(fone, index) in verificacaoTelefone.ids_cadastrados" :key="index">
                                            {{ fone }}<span v-if="index < verificacaoTelefone.ids_cadastrados.length - 1 ">,</span>
                                            </span>
                                        </v-flex>
                                        <v-layout wrap justify-space-between v-if="verificacaoTelefone.pessoa" class="error--text">
                                            <v-flex xs12><h4 class="text-xs-center">Cadastro Firebase</h4></v-flex>
                                            <v-flex xs11>Nome: {{ verificacaoTelefone.pessoa.nome_completo }}</v-flex>
                                            <v-flex xs5>CPF: {{ verificacaoTelefone.pessoa.cpf }}</v-flex>
                                            <v-flex xs5>ID: {{ verificacaoTelefone.pessoa.id_pessoa }}</v-flex>
                                            <v-flex xs11>E-mail: {{ verificacaoTelefone.pessoa.email }}</v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="4">
                        <v-layout justify-space-around wrap full-width>
                            <v-flex xs11>
                                <v-text-field
                                    label="CNPJ"
                                    mask="##.###.###/####-##"
                                    v-model="empresa.cnpj"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-text-field>
                                <h5 class="error--text" v-show="empresaExiste">Já existe uma empresa com esse CNPJ</h5>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field
                                    label="Nome Fantasia"
                                    v-model="empresa.nome_fantasia"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field
                                    label="Razão Social"
                                    v-model="empresa.razao_social"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field
                                    label="Email"
                                    v-model="empresa.email"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-checkbox
                                    v-model="empresa.is_empresa_parceira"
                                    color="primary"
                                    class="mt-0"
                                >
                                    <template slot="label">
                                        <span class="body-2 grey--text">Empresa Parceira?</span>
                                    </template>
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="5">
                        <v-layout justify-space-around wrap full-width>
                            <v-flex xs11>
                                <v-textarea
                                    label="Descrição"
                                    v-model="empresa.descricao"
                                    counter
                                    maxlength="700"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-textarea>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field
                                    label="Site da empresa"
                                    placeholder="https://www.dominio.com.br/"
                                    v-model="empresa.site"
                                    maxlength="255"
                                    counter
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-select
                                    :items="[
                                        { text: 'Fixo', value: 1 },
                                        { text: 'Movel', value: 2 }
                                    ]"
                                    v-model="tipo_telefone"
                                    label="Tipo de telefone"
                                ></v-select>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    label="Telefone"
                                    :mask="tipo_telefone === 2 ? '(##) # ####-####' : '(##) ####-####'"
                                    v-model="empresa.contato1"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field
                                    label="Desconto Apetrus"
                                    v-model="empresa.desconto_apetrus"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    type="number"
                                ></v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="6" style="hight: 100%;">
                        <v-layout justify-center column full-width  style="hight: 100%;">
                            <v-flex align-self-center>
                                <img v-if="imagem && mostrar" :src="imagem" alt="Logo da empresa">
                                <v-card color="grey" height="250" width="250" v-if="!imagem && !croppingLogo">
                                    <v-layout justify-center align-center fill-height>
                                        <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                                    </v-layout>
                                </v-card>
                                <v-btn class="mt-3 mb-3" block color="primary" @click="$refs.logoInput.click()" v-if="mostrar">
                                    Inserir imagem
                                    <input
                                        type="file"
                                        style="display:none"
                                        accept="image/*"
                                        ref="logoInput"
                                        @input="carregarImagem"
                                    />
                                </v-btn>
                            </v-flex>
                            <v-flex xs12 v-show="croppingLogo">
                                <vue-croppie
                                    ref="croppieRef"
                                    :enableExif="true"
                                    :enforceBoundary="true"
                                    :enableResize="false"
                                    :enableOrientation="false"
                                    :mouseWheelZoom="true"
                                    :showZoomer="false"
                                    :boundary="{ width: 250, height: 250 }"
                                    :viewport="{ width: 200, height: 200, type : 'circle' }"
                                    ></vue-croppie>
                                    <v-btn
                                    flat
                                    @click="recortarImagem"
                                    color="grey darken-2"
                                    block
                                    class="mt-3"
                                    >Recortar imagem</v-btn>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="7" style="hight: 100%;">
                        <v-layout justify-center align-center fill-height  style="hight: 100%;">
                            <v-flex align-self-center>
                                <img v-if="capa && mostrar2" :src="capa" alt="Banner da empresa" width="100%">
                                <v-card color="grey" height="250" width="450" v-if="!capa && !croppingCapa">
                                    <v-layout justify-center align-center fill-height>
                                        <div class="title white--text pa-4 text-xs-center">Sem imagem</div>
                                    </v-layout>
                                </v-card>
                                <v-btn class="mt-3" block color="primary" @click="$refs.capaInput.click()" v-if="mostrar2">
                                    Inserir imagem
                                    <input
                                        type="file"
                                        style="display:none"
                                        accept="image/*"
                                        ref="capaInput"
                                        @input="carregarImagem"
                                    />
                                </v-btn>
                            </v-flex>
                        <v-flex xs12 v-show="croppingCapa">
                            <vue-croppie
                            ref="croppieCapaRef"
                            :enableExif="true"
                            :enforceBoundary="true"
                            :enableResize="false"
                            :enableOrientation="false"
                            :mouseWheelZoom="true"
                            :showZoomer="false"
                            :boundary="{ width: 450, height: 250 }"
                            :viewport="{ width: 350, height: 200}"
                            ></vue-croppie>
                            <v-btn
                            flat
                            @click="recortarImagem"
                            color="grey darken-2"
                            block
                            class="mt-3"
                            >Recortar imagem</v-btn>
                        </v-flex>
                      </v-layout>
                    </v-stepper-content>
                    <v-stepper-content step="8">
                        <v-layout justify-space-around wrap full-width>
                            <v-flex xs11>
                                <v-text-field
                                    label="CEP"
                                    v-model="endereco.cep"
                                    mask="##.###-###"
                                    @keyup="pesquisarCep"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                label="Logradouro"
                                v-model="endereco.logradouro"
                                :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-text-field
                                label="Número"
                                v-model="endereco.numero"
                                :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    label="Complemento"
                                    v-model="endereco.complemento"
                                    :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs5>
                                <v-text-field
                                    label="Bairro"
                                    v-model="endereco.bairro"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs7>
                                <v-text-field
                                    label="Cidade"
                                    v-model="endereco.cidade"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs3>
                                <v-select
                                    label="Estado"
                                    :items="estados"
                                    v-model="endereco.estado"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-select>
                            </v-flex>
                            <v-flex xs11>
                                <v-text-field
                                    label="País"
                                    v-model="endereco.pais"
                                    :rules="[(v) => !!v || 'Esse campo é obrigatório']"
                                    :disabled="!!empresaParceira && !!empresaParceira.endereco"
                                ></v-text-field>
                            </v-flex>
                            <v-flex xs8>
                                <v-checkbox
                                    v-model="has_geolocation"
                                    color="primary"
                                    class="mt-0"
                                >
                                    <template slot="label">
                                        <span class="body-2 grey--text">Cadastrar latitude e longitude desse endereço?</span>
                                    </template>
                                </v-checkbox>
                            </v-flex>
                        </v-layout>
                    </v-stepper-content>
                </v-stepper-items>
            </v-stepper>
        </v-card-text>
        <v-card-actions class="justify-space-around">
            <v-btn round class="mb-2" @click="$emit('fechar')">Fechar</v-btn>
            <v-btn round class="mb-2" color="primary" @click="confirmar">
                {{textBtnConfirme()}}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    props: ['empresaParceira'],
    data: () => ({
        step: 1,
        estados: [
            'AC',
            'AL',
            'AP',
            'AM',
            'BA',
            'CE',
            'ES',
            'GO',
            'MA',
            'MT',
            'MS',
            'MG',
            'PA',
            'PB',
            'PR',
            'PE',
            'PI',
            'RJ',
            'RN',
            'RS',
            'RO',
            'RR',
            'SC',
            'SP',
            'SE',
            'TO',
            'DF'
        ],
        verificacaoTelefone: {
            cadastrado: false,
            quantidade: 0,
            ids_cadastrados: [],
            pessoa: undefined
        },
        search_label: 'email',
        search: '',
        lista_de_pessoa: [],
        empresaExiste: false,
        croppingLogo: false,
        croppingCapa: false,
        mostrar: true,
        mostrar2: true,
        imagem: null,
        capa: null,
        has_geolocation: false,
        tipo_telefone: 2,
        representante: {
            id_pessoa: undefined,
            nome: '',
            sobrenome: '',
            cpf: '',
            telefone: '',
            email: ''
        },
        empresa: {
            nome_fantasia: '',
            razao_social: '',
            cnpj: '',
            email: '',
            is_empresa_parceira: false,
            url_banner: '',
            descricao: '',
            site: '',
            url_logo: '',
            contato1: ''
        },
        endereco: {
            cep: '',
            logradouro: '',
            numero: '',
            bairro: '',
            cidade: '',
            estado: '',
            pais: 'Brasil'
        }
    }),
    computed: {
        text_title () {
            switch (this.step) {
                case 1:
                    return 'Procurar por representante'
                case 2:
                    return 'Selecione um representante'
                case 3:
                    return 'Cadastre o Representante'
                case 4:
                    return 'Cadastre Uma Empresa'
                case 5:
                    return 'Cadastre as Informações da Empresa Parceira'
                case 6:
                    return 'Insira o Logo da Empresa'
                case 7:
                    return 'Insira o Banner da Empresa'
                case 8:
                    return 'Cadastrar Enderenço da empresa'
                default:
                    return ''
            }
        }
    },
    methods: {
        textBtnConfirme () {
            if (this.step === 1) return 'Procurar'
            else if (this.step === 2 || this.step === 3 || this.step === 4 || this.step === 5) return 'Avançar'
            else if ((this.step === 6 && this.imagem) || (this.step === 7 && this.capa)) return 'Avançar'
            else if (this.step === 8) return 'Cadastrar'
            else return 'Pular'
        },
        confirmar () {
            switch (this.step) {
                case 1:
                    this.procurarRepresentante()
                    break
                case 2:
                    if (this.representante.id_pessoa) {
                        this.step = 4
                    } else {
                        this.$emit('error', 'Você precisa selecionar um usuário.')
                    }
                    break
                case 3:
                    this.cadastrarPessoa()
                    break
                case 4:
                    if (this.empresaExiste) {
                        this.$emit('error', 'Essa empresa já existe.')
                        break
                    }

                    if (this.empresa.is_empresa_parceira === true) {
                        this.step++
                        break
                    }

                    this.step = 8
                    break
                case 5:
                    this.step++
                    break
                case 6:
                    if (this.imagem && this.imagem !== this.empresa.url_logo) {
                        this.inserirImagemFirebase(this.imagem, 'logo')
                    } else this.step++
                    break
                case 7:
                    if (this.capa && this.capa !== this.empresa.url_banner) {
                        this.inserirImagemFirebase(this.capa, 'banner')
                    } else this.step++
                    break
                case 8:
                    if (this.empresaParceira) this.tornarParceira()
                    else this.cadastrarEmpresa()
                    break
                default:
                    this.$emit('error', 'Tela inválida')
            }
        },
        procurarRepresentante () {
            const data = {}
            data[`${this.search_label}__icontains`] = this.search
            this.$store.dispatch('procurarPessoasPorAdm', { filtros: data }).then(json => {
                if (json.count === 0) {
                    this.step = 3
                    if (this.search_label === 'cpf') this.representante.cpf = this.search
                    else this.representante.email = this.search
                } else if (json.count > 1) {
                    this.lista_de_pessoa = json.results
                    this.step = 2
                } else {
                    this.representante = json.results[0]
                    this.step = 4
                }
            })
        },
        procurarEmpresa () {
            this.$store.dispatch('procurarEmpresasPorAdm', { filtros: { cnpj__icontains: this.empresa.cnpj } }).then(json => {
                if (json.length === 0) {
                    this.empresaExiste = false
                } else {
                    this.empresaExiste = true
                }
            })
        },
        cadastrarPessoa () {
            this.$store.dispatch('cadastroPessoa', { cadUser: this.representante })
            .then(json => {
                this.representante.id_pessoa = json.id_pessoa
                this.$emit('success', 'Usuário cadastrado com sucesso.')
                this.step++
            })
        },
        cadastrarEmpresa () {
            if (this.endereco.cep && this.endereco.cep !== '' && this.endereco.cep !== null) {
                this.empresa.endereco = this.endereco
            }
            const data = { ...this.empresa, ...this.representante }
            this.$store.dispatch('cadastrarEmpresa', data).then(() => {
                this.$emit('success', 'Empresa cadastrada com sucesso.')
                this.limparCampos()
                this.step = 1
                this.$emit('carregar')
            })
        },
        tornarParceira () {
            const data = { ...this.empresaParceira }
            data.is_empresa_parceira = true
            data.nome_fantasia = this.empresa.nome_fantasia ? this.empresa.nome_fantasia : null
            data.razao_social = this.empresa.razao_social ? this.empresa.razao_social : null
            data.cnpj = this.empresa.cnpj ? this.empresa.cnpj : null
            data.contato1 = this.empresa.contato1 ? this.empresa.contato1 : null
            data.url_logo = this.empresa.url_logo ? this.empresa.url_logo : null
            data.site = this.empresa.site ? this.empresa.site : null
            data.descricao = this.empresa.descricao ? this.empresa.descricao : null
            data.desconto_apetrus = this.empresa.desconto_apetrus ? this.empresa.desconto_apetrus : null
            data.url_banner = this.empresa.url_banner ? this.empresa.url_banner : null
            data.endereco = this.empresaParceira.endereco ? this.empresaParceira.endereco : { ...this.endereco }
            data.latitude = this.empresa.latitude ? this.empresa.latitude : null
            data.longitude = this.empresa.longitude ? this.empresa.longitude : null
            this.$store.dispatch('tornarParceira', data).then(() => {
                this.$emit('success', 'Essa empresa agora é uma parceira.')
                this.$emit('carregar')
                this.$emit('fechar')
            })
        },
        pesquisarCep () {
            fetch(`https://viacep.com.br/ws/${this.endereco.cep}/json/`, {
                method: 'get',
                mode: 'cors',
                headers: {
                Accept: 'application/json'
                }
            })
                .then(res => res.json())
                .then(json => {
                this.endereco.logradouro = json.logradouro
                this.endereco.bairro = json.bairro
                this.endereco.cidade = json.localidade
                this.endereco.estado = json.uf
                })
        },
        carregarImagem (event) {
            if (this.step === 6) {
                this.imagem = null
                this.mostrar = false
            } else {
                this.capa = null
                this.mostrar2 = false
            }
            if (event.target.files && event.target.files[0]) {
                let imagem = event.target.files[0]
                let reader = new FileReader()
                reader.onloadend = e => {
                    if (this.step === 6) {
                        this.croppingLogo = true
                        this.$refs.croppieRef.bind({
                            url: reader.result
                        })
                        this.$nextTick(() => {
                            this.$refs.croppieRef.setZoom(0.1)
                        })
                    } else {
                        this.croppingCapa = true
                        this.$refs.croppieCapaRef.bind({
                            url: reader.result
                        })
                        this.$nextTick(() => {
                            this.$refs.croppieCapaRef.setZoom(0.1)
                        })
                    }
                }
                reader.readAsDataURL(imagem)
            }
        },
        recortarImagem () {
            let options = {
                type: 'base64',
                format: 'png'
            }
            if (this.step === 6) {
                this.mostrar = true
                options.circle = true
            } else this.mostrar2 = true

            const refscroppie = this.step === 6 ? this.$refs.croppieRef : this.$refs.croppieCapaRef
            refscroppie.result(options, output => {
                if (this.step === 6) {
                    this.imagem = output
                    this.croppingLogo = false
                } else {
                    this.capa = output
                    this.croppingCapa = false
                }
            })
        },
        async inserirImagemFirebase (imagem, local) {
            const data = {
                arquivo: imagem,
                id: this.empresa.cnpj,
                local: local,
                tipo: 'png',
                rota: 'empresas'
            }
            const variavel = await this.$store.dispatch('inserirArquivoFirebase', data)
            if (this.step === 6) this.empresa.url_logo = variavel
            else this.empresa.url_banner = variavel
            this.step++
        },
        verificarTelefone () {
            this.$store.dispatch('verificarTelefone', {
                id_pessoa: null,
                telefone: this.representante.telefone.slice(3, 11)
            }).then(json => {
                this.verificacaoTelefone = json
            })
        },
        limparCampos () {
            this.empresa = {
                nome_fantasia: '',
                razao_social: '',
                cnpj: '',
                email: '',
                is_empresa_parceira: false,
                url_banner: '',
                descricao: '',
                site: '',
                url_logo: '',
                contato1: ''
            }
            this.endereco = {
                cep: '',
                logradouro: '',
                numero: '',
                bairro: '',
                cidade: '',
                estado: '',
                pais: 'Brasil'
            }
            this.representante = {
                id_pessoa: undefined,
                nome: '',
                sobrenome: '',
                cpf: '',
                telefone: '',
                email: ''
            }
            this.search_label = 'email'
            this.search = ''
            this.lista_de_pessoa = []
            this.empresaExiste = false
            this.croppingLogo = false
            this.croppingCapa = false
            this.mostrar = true
            this.mostrar2 = true
            this.imagem = null
            this.capa = null
            this.has_geolocation = false
            this.tipo_telefone = 2
        },
        buscarCoordenadas () {
            return this.$store.dispatch('pegarCoordenadas', {
                logradouro: this.endereco.logradouro,
                numero: this.endereco.numero,
                bairro: this.endereco.bairro,
                cidade: this.endereco.cidade,
                estado: this.endereco.estado
            })
            .then(json => {
                this.empresa.latitude = json.latitude
                this.empresa.longitude = json.longitude
            })
        }
    },
    watch: {
        'empresa.cnpj' (val) {
            if (val) {
                this.procurarEmpresa()
            } else {
                this.empresaExiste = false
            }
        },
        'representante.telefone' (val) {
            if (val && val.length === 11) {
                this.verificarTelefone()
            } else {
                this.verificacaoTelefone.pessoa = undefined
                this.verificacaoTelefone.ids_cadastrados = []
                this.verificacaoTelefone.cadastrado = false
                this.verificacaoTelefone.quantidade = 0
            }
        },
        has_geolocation (val) {
            if (val && this.endereco.cep) {
                this.buscarCoordenadas()
            } else {
                this.empresa.latitude = null
                this.empresa.longitude = null
            }
        }
    },
    beforeMount () {
        if (this.empresaParceira) {
            this.empresa = this.empresaParceira
            this.endereco = this.empresaParceira.endereco
            this.representante = this.empresaParceira.administrador
            this.imagem = this.empresaParceira.url_logo
            this.capa = this.empresaParceira.url_banner
            this.step = 5
        }
    }
}
</script>
